import {useState} from "react";

import uploadImage from "@images/popups/upload.png";
import {ControlButton} from "@ui/buttons/ControlButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {SmallDesc} from "@ui/descriptions/SmallDesc";
import Dropzone from "react-dropzone";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const DropZone = (props) => {
  const {t} = useTranslation();
  const {maxFiles, multiple, accept, onUpload, size} = props;

  const [fileInfo, setFileInfo] = useState({
    files: [],
    error: false,
    loading: false,
    progress: 0,
  });

  const onDrop = () => {
    setFileInfo((prev) => ({...prev, loading: true}));
  };

  const handleDropAccept = (dropped) => {
    setFileInfo((prev) => ({...prev, loading: false}));

    const files = dropped.map((file) => ({
      name: file.name,
      size: file.size,
    }));

    if (multiple) {
      setFileInfo({
        files,
        error: false,
        progress: 0,
      });

      onUpload(dropped);
    } else {
      const [file] = dropped;

      if (file) {
        setFileInfo({
          files: [{name: file.name, size: file.size}],
          error: false,
          progress: 0,
        });

        onUpload(file);
      }
    }
  };

  const handleDropReject = () => {
    setFileInfo({...fileInfo, error: true});
  };

  return (
    <Dropzone
      maxFiles={maxFiles || 0}
      multiple={multiple || false}
      accept={accept}
      maxSize={size}
      onDrop={onDrop}
      onDropAccepted={handleDropAccept}
      onDropRejected={handleDropReject}
    >
      {({getRootProps, getInputProps}) => (
        <div
          {...getRootProps()}
          className={styles.dropzoneContainer}
        >
          <input {...getInputProps()} />

          <div
            className={styles.dropzone}
            style={{
              border: fileInfo.error
                ? "2rem dashed var(--red)"
                : "2rem dashed var(--violet)",
            }}
          >
            <div className={styles.dropzoneHead}>
              <RootDesc>
                <b>{t("dropzone.title")}</b>
              </RootDesc>

              <img
                src={uploadImage}
                alt={"upload"}
              />

              <RootDesc>
                <span>{t("dropzone.union")}</span>
              </RootDesc>
            </div>

            <ControlButton
              color={"var(--violet)"}
              txt={t("button.browse_files")}
            />

            <SmallDesc>
              <span
                className={
                  "inline-block w-[100%] text-center text-[var(--grey)]"
                }
                dangerouslySetInnerHTML={{
                  __html: t("dropzone.size", {
                    count: size / 1024 / 1024,
                    accept: Object.values(accept).join(", "),
                  }),
                }}
              />
            </SmallDesc>
          </div>

          {fileInfo.error && (
            <SmallDesc>
              <span className={"block text-center text-[var(--red)]"}>
                {t("dropzone.error")}
              </span>
            </SmallDesc>
          )}
        </div>
      )}
    </Dropzone>
  );
};
